import * as chrono from 'chrono-node'
import get from 'lodash/get'

import { getChronoDates } from '@utils/chrono'

import { SearchPrefix } from './OmniSearch.types'

const removeFocusIn = (str: string): string => {
  return str.substring(2)
}

export const sanitizeSearchTerm = (term: string) => {
  return term.replace(/'/g, ' ')
}

const focusInIsValid = (str: string): boolean => {
  const searchPrefixes = [
    SearchPrefix.BOOKINGS,
    SearchPrefix.PROPERTIES,
    SearchPrefix.USERS,
    SearchPrefix.HOMEOWNERS,
  ]

  return searchPrefixes.includes(str as SearchPrefix)
}

const searchForDates = (
  input: string,
): { dates?: { startDate: string; endDate: string }; term: string } => {
  const parsedDate = chrono.parse(input)[0]
  const termWithoutDates = removeDatePattern(input, parsedDate)

  const dates = getChronoDates(parsedDate)

  return { dates, term: termWithoutDates }
}

export const parseSearchInput = (
  input: string,
): { focusIn: SearchPrefix; term: string; dates?: { startDate: string; endDate: string } } => {
  let focusIn: SearchPrefix = SearchPrefix.ANY
  let term: string = input

  const maybeFocusIn = input.substring(0, 2)

  if (focusInIsValid(maybeFocusIn)) {
    focusIn = maybeFocusIn as SearchPrefix
    term = removeFocusIn(input).trim()
  }

  const datesSearch = searchForDates(term)

  return {
    focusIn,
    dates: datesSearch.dates,
    term: datesSearch.term,
  }
}

export const removeDatePattern = (searchTerm: string, parsedDate: string): string => {
  return searchTerm.replace(get(parsedDate, 'text', ''), '').trim()
}
